import * as BABYLON from 'babylonjs';
import Vec3 from "../../../shared/vec3";
import { Orientation } from '../../../shared/interfaces'
import ExpositionRendering from "../rendering/ExpositionRendering";
import ShadowGenerator = BABYLON.ShadowGenerator;

export default class VideoPlane {

  planeHolder: BABYLON.TransformNode;

  constructor(url: string, position: Vec3, orientation: Orientation, scene: BABYLON.Scene, shadowGenerator: ShadowGenerator = null) {
    let angle;
    switch (orientation) {
      case Orientation.NORTH:
        angle = Math.PI;
        break;
      case Orientation.EAST:
        angle = 1.5 * Math.PI;
        break;
      case Orientation.SOUTH:
        angle = 0;
        break;
      case Orientation.WEST:
        angle = 0.5 * Math.PI;
        break;
      default:
        angle = 0;
    }

    const boxHeight = 1.5;
    const boxWidth = 1.5;
    const boxDepth = 0.1;
    const wallDistance = 0.01;
    const margin = 0.05;

    const imageWidth = boxWidth - (2 * margin);
    const imageHeight = imageWidth * (3 / 4);

    const box = BABYLON.MeshBuilder.CreateBox('videoBox' + url, { width: boxWidth, height: boxHeight, depth: boxDepth })
    const boxMaterial = new BABYLON.StandardMaterial("videoBoxMaterial", scene);
    boxMaterial.diffuseColor = BABYLON.Color3.FromHexString('#ffffff');
    box.material = boxMaterial;
    if(shadowGenerator) {
      ExpositionRendering.addShadows(box, shadowGenerator);
    }
    box.rotationQuaternion = BABYLON.Quaternion.RotationAxis(new BABYLON.Vector3(0, 1, 0), angle);

    const plane = BABYLON.MeshBuilder.CreatePlane('videoPlane'+url, { height: imageHeight, width: imageWidth }, scene);

    plane.rotationQuaternion = BABYLON.Quaternion.RotationAxis(new BABYLON.Vector3(0, 1, 0), angle);
    plane.translate(BABYLON.Axis.Z, -(boxDepth / 2 + wallDistance))
    plane.translate(BABYLON.Axis.Y, (boxHeight - imageHeight) / 2 - margin)

    const imageMaterial = new BABYLON.StandardMaterial("image_" + url, scene);
    console.log('url:', url);
    imageMaterial.diffuseTexture = new BABYLON.Texture(url, scene)
    plane.material = imageMaterial;

    this.planeHolder = new BABYLON.TransformNode('planerHolder_' + url);
    plane.parent = this.planeHolder;
    box.parent = this.planeHolder;

    this.planeHolder.position.x = position.x;
    this.planeHolder.position.y = position.y + boxHeight / 2;
    this.planeHolder.position.z = position.z;
  }

  getMesh() {
    return this.planeHolder;
  }

}
